/* eslint-disable import/prefer-default-export */
import { defineStore } from 'pinia';
import axios from 'axios';
export const useCodeStore = defineStore('codeStore', {
  state: () => ({
    activityList: [],
    taskList: [],
    expenselist: []
  }),
  actions: {
    async activityCodes() {
      try {
        if (Object.keys(this.activityList).length) {
          return this.activityList;
        }
        const response = await axios({
          url: '/codes/activity'
        });
        const activityList = response.data.map(code => ({
          id: code.id,
          value: code.id,
          label: `${code.id} ${code.label}`,
          listLabel: `${code.id} ${code.label}`,
          disabled: code.isDisabled
        }));
        this.$patch({
          activityList
        });
        return activityList;
      } catch (error) {
        throw new Error(error.response.data.message);
      }
    },
    async taskCodes() {
      try {
        if (Object.keys(this.taskList).length) {
          return this.taskList;
        }
        const response = await axios({
          url: '/codes/task'
        });
        const taskList = response.data.map(code => ({
          id: code.id,
          value: code.id,
          label: `${code.id} ${code.label}`,
          listLabel: `${code.id} ${code.label}`,
          disabled: code.isDisabled
        }));
        this.$patch({
          taskList
        });
        return taskList;
      } catch (error) {
        throw new Error(error.response.data.message);
      }
    },
    async expenseCodes() {
      try {
        if (Object.keys(this.expenselist).length) {
          return this.expenselist;
        }
        const response = await axios({
          url: '/codes/expense'
        });
        const expenselist = response.data.map(code => ({
          id: code.id,
          label: `${code.id} ${code.label}`,
          disabled: code.isDisabled
        }));
        this.$patch({
          expenselist
        });
        return expenselist;
      } catch (error) {
        throw new Error(error.response.data.message);
      }
    }
  }
});